export const returnTwoDigits = (digit) => {
  const formattedNumber = `0${digit}`.slice(-2);

  return formattedNumber;
};
